import React from 'react';
import PropTypes from 'prop-types';

import HeaderCell from './headerCells/HeaderCell';
import { ensureKeyed } from '../../utils';

const Header = ({
  columns,
  onSort,
  sort,
  superHeader
}) => (
  <thead>
    {superHeader}
    <tr>
      {
        columns.map((column) => (
          <HeaderCell
            {...column}
            onSort={onSort}
            sort={sort}
            key={column.sortName}
          />
        )).map(ensureKeyed())
      }
    </tr>
  </thead>
);


Header.propTypes = {
  /** Function that returns contents for a potental extra header row above the normal one*/
  superHeader: PropTypes.func,

  /** The columns that we want a header for */
  columns: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string
    ]),
    sortName: PropTypes.string,
    type: PropTypes.string
  })),

  /** A function that is called on a column's sortName on click */
  onSort: PropTypes.func,

  /** The selected sort */
  sort: PropTypes.shape({
    column: PropTypes.string,
    order: PropTypes.string
  })
};

Header.defaultProps = {
  columns: [],
  onSort: () => '',
  sort: {}
};

export default Header;
